import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import * as commonActions from '../../common/redux/actions';
import ExternalApiHeaderNav from '../ExternalApiHeaderNav';
import { snakeCaseToTitleCase } from '../../../common/utils/api_utils';
import CustomLoader from '../../common/CustomLoader';
import ParentDocCard from '../../common/ParentDocCard';
import ParentContentCard from '../../common/ParentContentCard';
import ZapierApiList from './ZapierApiList';
import { CHAT_GPT, ZAPIER } from 'drapcode-constant';
import { checkToShowSaveBtn } from '../../plugin/utils';
import { parseExtractPluginCode } from '../../../common/utils/plugin_utils';

export class Zapier extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { page: 0, searchTerm: '', limit: 25, headers: [] };
  componentDidMount = async () => {
    const { match, actions, home } = this.props;
    const { projectId, version } = match.params;
    const { iPlugins } = home;
    await actions.loadExternalApis({
      projectId,
      version,
      page: this.state.page,
      externalApiType: ZAPIER,
      limit: this.state.limit,
    });
    await actions.loadCollections({ projectId, version });

    await actions.loadExternalDatabase({ projectId, version });
    const extenalData = this.props.externalapi.externalDatabase;
    if (extenalData) {
      const dataTypes = [...new Set(extenalData.map((item) => item.type))];
      this.setState({ headers: dataTypes });
    }
    actions.loadProjectDetail({ projectId, version });
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { home: nextHome } = nextProps;
    const { home } = this.props;
    const { iPlugins: nextIPlugins } = nextHome;
    if (!nextIPlugins || nextIPlugins.length === 0) {
      return true;
    }
    const { iPlugins } = home;
    if (!checkToShowSaveBtn(nextIPlugins, iPlugins)) {
      const headers = parseExtractPluginCode(nextIPlugins, 'EXTERNALAPI');
      this.setState({ headers });
    }
    return true;
  }
  componentDidUpdate(prevProps) {
    const { projectDetail } = this.props.common;
    if (prevProps.common.projectDetail !== projectDetail) {
      if (projectDetail && projectDetail.projectType) {
        const { projectType } = projectDetail;
      }
    }
  }
  updateSearchTerm = (value) => {
    this.setState({ searchTerm: value });
  };

  onPageChange = (val) => {
    const { projectId, version } = this.props.match.params;
    const { limit, searchTerm } = this.state;

    this.props.actions.loadExternalApis({
      projectId,
      page: val.selected,
      limit,
      version,
      externalApiType: ZAPIER,
      searchTerm,
    });

    this.setState({ page: val.selected });
  };

  handleSearch = () => {
    const { projectId, version } = this.props.match.params;
    const { page, limit, searchTerm } = this.state;
    this.props.actions.loadExternalApis({
      projectId,
      version,
      page,
      limit,
      searchTerm,
      externalApiType: ZAPIER,
    });
  };

  render() {
    const { match, externalapi, home } = this.props;
    const { iPlugins } = home;
    const chatGptPlugin = iPlugins && iPlugins.find((e) => e.code === CHAT_GPT);
    const { projectId, version } = match.params;
    const { loadExternalApisPending } = externalapi;
    const { headers } = this.state;
    return (
      <div className="main">
        <div className="section">
          <div className="container externalapi">
            <ExternalApiHeaderNav
              version={version}
              activeTab={ZAPIER}
              projectId={projectId}
              headers={headers}
              enableChatGpt={chatGptPlugin ? true : false}
            />

            <div className="row mx-auto">
              <ParentContentCard
                title={snakeCaseToTitleCase(ZAPIER)}
                headerLink={`/externalapi/${version}/v/${projectId}/zapier/create`}
                headerTitle="Create External API"
                headerText="Create"
                isSearch={true}
                updateSearchTerm={this.updateSearchTerm}
                handleSearch={this.handleSearch}
                datasourceIconSvg={ZAPIER}
              >
                {loadExternalApisPending ? (
                  <div className="text-center">
                    <CustomLoader loading={loadExternalApisPending} size="20px" color="#303453" />
                  </div>
                ) : (
                  <ZapierApiList
                    actions={this.props.actions}
                    externalapi={this.props.externalapi}
                    projectId={projectId}
                    history={this.props.history}
                    externalApiType={ZAPIER}
                    page={this.state.page}
                    limit={this.state.limit}
                    onPageChange={this.onPageChange}
                    version={version}
                  />
                )}
              </ParentContentCard>
              <ParentDocCard>
                <h5>
                  <b>About Zapier API</b>
                </h5>
                <p>
                  DrapCode supports Zapier to send or process data using Zapier API integration.
                </p>
                <br />
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalapi: state.externalapi,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Zapier);
